const createTextWithLink = ({
  text,
  url,
  containerTag = "p",
  openInNewTab = true,
  ariaLabel,
  allowHTML = false
}) => {
  if (!text || !url) {
    return null;
  }
  const container = document.createElement(containerTag);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  if (openInNewTab) {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  }
  if (ariaLabel) {
    link.setAttribute("aria-label", ariaLabel);
  }
  if (allowHTML) {
    link.innerHTML = text;
  } else {
    link.textContent = text;
  }
  container.appendChild(link);
  return container;
};
export {
  createTextWithLink
};
//# sourceMappingURL=createTextWithLink.js.map
